import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './ReviewSection.css';
import ReviewCard from '../ReviewCard/ReviewCard';
import { renderTextWithNormalDash } from '../../utils/textFormatters';

const ReviewSection = () => {
  const [reviews, setReviews] = useState([
    {
      text: "Elite Optix gave me the best eyewear experience I've ever had. Luxury from start to finish.",
      name: "S. Martin",
      org: "Martin Foundation",
      img: "/pfp-1.png"
    },
    {
      text: "Elite Optix gave me the best eyewear experience I've ever had. Luxury from start to finish.",
      name: "J. Marsha",
      org: "Marsha Co.",
      img: "/pfp-2.png"
    },
    {
      text: "Elite Optix gave me the best eyewear experience I've ever had. Luxury from start to finish.",
      name: "T. Collins",
      org: "Optix Labs",
      img: "/pfp-1.png"
    },
  ]);

  const [translate, setTranslate] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTranslate(-100); // slide left
    setTimeout(() => {
      setReviews(prev => {
        const [first, ...rest] = prev;
        return [...rest, first];
      });
    setTranslate(0);
    setIsAnimating(false);
    }, 400);
  };

  const handlePrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTranslate(100); // slide right
    setTimeout(() => {
      setReviews(prev => {
        const last = prev[prev.length - 1];
        const rest = prev.slice(0, -1);
        return [last, ...rest];
      });
      setTranslate(0);
      setIsAnimating(false);
    }, 400);
  };

  return (
    <section className="review-section">
      <Container>
        <div className="text-center review-heading">
          <h2>Don't take our word for it.</h2>
          <p className="review-sub">
            Over <span className="accent">{renderTextWithNormalDash("100+")}</span> people trust us.
          </p>
        </div>

        <Row className="justify-content-center mt-4">
          <Col xs={12} lg={10} xl={12}>
            <div
              className="review-cards d-flex gap-3 justify-content-center overflow-hidden"

            >
              {reviews.map((review, idx) => (
                <ReviewCard
                  key={idx}
                  text={review.text}
                  name={review.name}
                  org={review.org}
                  img={review.img}
                  idx={idx}
                  translate={translate}
                  isAnimating={isAnimating}
                />
              ))}
            </div>
          </Col>
        </Row>

        <div className="review-controls d-flex justify-content-center mt-4">
          <Button
            variant="light"
            className="review-arrow prev"
            aria-label="Previous"
            onClick={handlePrev}
            disabled={isAnimating}
          >
            <img src="/icons/arrow-2.png" alt="prev" />
          </Button>
          <Button
            variant="light"
            className="review-arrow next"
            aria-label="Next"
            onClick={handleNext}
            disabled={isAnimating}
          >
            <img
              src="/icons/arrow-2.png"
              alt="next"
              aria-label='prev'
            />
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default ReviewSection;
